module.exports = __webpack_public_path__ + "static/media/logo-1.6fc18d72.png";